import { Component } from '@angular/core'
import { OrderDetailsComponent } from '@monorepo-channels/components/feature-porto-bank'

@Component({
	standalone: true,
	selector: 'porto-bank-order-details-page',
	imports: [OrderDetailsComponent],
	template: '<feature-porto-bank-order-details/>',
})
export class OrdersDetailsPageComponent {}
